// Used to prevent bugs when using timeouts with large delays
// https://developer.mozilla.org/en-US/docs/Web/API/WindowOrWorkerGlobalScope/setTimeout#maximum_delay_value
export const MAX_TIMEOUT_DELAY_IN_MILLISECONDS = 2000000000;
